<template>
  <div>
    <div class="header bg-gradient-custom py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7"></div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100"></div>
    </div>
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <strong>Iniciar Sesión</strong>
              </div>
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(login)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="username"
                    prepend-icon="ni ni-single-02"
                    placeholder="Usuario"
                    v-model="model.username"
                  ></base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="password"
                    :rules="{ required: true }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Contraseña"
                    v-model="model.password"
                  ></base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      :disabled="loading"
                    >
                      <span v-if="!loading">Entrar</span>
                      <span v-else>Cargando...</span>
                    </base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      model: {
        username: '',
        password: '',
      },
      loading: false,
    };
  },
  methods: {
    async login() {
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: this.model.username,
            password: this.model.password,
          }),
        });

        const data = await response.json();

        if (data.token && data.rol) {
          // Almacenar el token y la información del usuario
          localStorage.setItem('token', data.token);
          localStorage.setItem('idOrgValue', data.idOrg);
          localStorage.setItem('rol', data.rol);
          localStorage.setItem('isAuthenticated', true); // Marcar como autenticado

          // Redirigir según el rol del usuario
          if (data.rol === 'admin') {
            this.$router.push('/dashboard');
          } else if (data.rol === 'user') {
            this.$router.push('/dashboardUser');
          } else {
            this.mostrarError('Rol no reconocido');
          }
          this.mostrarExito('Bienvenido');
        } else {
          this.mostrarError('Error al Iniciar Sesión, Revise sus datos');
        }
      } catch (error) {
        this.mostrarError('Error de Red: ' + error.message);
      }finally{
        this.loading = false;
      }
    },

    async fetchMultipleProtectedData(routes) {
      const token = localStorage.getItem('token');

      if (!token) {
        this.mostrarError('Token no presente. Usuario no autenticado.');
        return;
      }

      try {
        const results = await Promise.all(
          routes.map((route) => this.fetchProtectedData(route, token))
        );
        console.log('Resultados de las llamadas a APIs protegidas:', results);
      } catch (error) {
        console.error('Error al realizar llamadas a APIs protegidas:', error);
      }
    },

    async fetchProtectedData(route, token) {
      const response = await fetch(`${process.env.VUE_APP_API_URL}${route}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return response.json();
    },

    mostrarExito(mensaje) {
      Swal.fire({
        title: 'Éxito',
        text: mensaje,
        icon: 'success',
        confirmButtonText: 'OK',
      });
    },

    mostrarError(mensaje) {
      Swal.fire({
        title: 'Error',
        text: mensaje,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    },
  },
};
</script>